import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { useEffect, useMemo, useState } from 'react';
const Menu = () => {
  const [indexHum, setIndexNum] = useState(0);
  const [indexNum, setIndexNumsub] = useState(null)
  const navigate = useNavigate()
  const [windowpathname, setpathname] = useState("");
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);

  const location = useLocation();
  useEffect(() => {
    setpathname(location.pathname);
    // console.log(windowpathname, '0path name//////////////////')
  }, [location.pathname]);
  useEffect(() => {
    console.log(indexNum, 'index num......')
  }, [indexHum, indexNum])

  useMemo(() => {
    setIndexNumsub(null)
  }, [indexHum])
  const menu = [
    {
      label: "Dashboard",
      url: "dashboard",
      icon: "fa fa-tachometer"
    },

    {
      label: "Action All User",
      url: "alluser/all",
      icon: "fa fa-user",
      // subMenu: [
      //   {
      //     label: "Action all user",
      //     url: "alluser",
      //   }
      // ]
    },
    {
      label: "Management Master",
      // url: "category",
      icon: "fa fa-tachometer",
      subMenu: [
        {
          label: "Category",
          url: "category",
        },
        {
          label: "Sub Category",
          url: "subcategory",
        },
        {
          label: "How Its Work",
          url: "howitswork",
          icon: "fa fa-question-circle"
        },
         
        {
          label: "Cms",
          url: "cms",
          icon: "fa fa-database"
        },
      ]
    },
    { 
      label: "Form",
      // url: "formlist",
      icon: "fa fa-wrench",
      subMenu: [
        {
          label: "Form Listing",
          url: "formlist",
        },
        {
          label: "Form Management",
          url: "formmanagement",
        },
        {
          label: "Form Label Master",
          url: "labelmaster",
          icon: "fa fa-newspaper-o "
        },
        {
          label: "Option Management",
          url: "optionmanagement",
          icon: "fa fa-list-ul"
        }
      ]

    },



    // {
    //   label: "Notification",
    //   url: "notification",
    //   icon: "fa fa-bell"
    // },
    {
      label: "Profit",
      // url: "profit",
      icon: "fa fa-line-chart",
      subMenu: [
        {
          label: "Profit From Profile Adder",
          url: "added-profile-profit-list",
        },
        {
          label: "Profit Form Service User",
          url: "serviceuser",
        }
      ]
    },
    // {
    //   label: "Service",
    //   url: "serviceuser",
    //   icon: "fa fa-bookmark",
    //   subMenu: [
    //     {
    //       label: "Service User",
    //       url: "serviceuser",
    //     },
    //     {
    //       label: "Service Category",
    //       url: "servicecategory",
    //     },
    //     {
    //       label: "Service Provider",
    //       url: "serviceprovider",
    //     }

    //   ]
    // },
    {
      label: "Reports",
      // url: "reports",
      icon: "fa fa-file-text",
      subMenu: [
        {
          label: "Depth Line",
          url: "check-depth-line",
          icon: "fa fa-align-center"
        },
        {
          label: "Review",
          url: "review-list",
          icon: "fa fa-align-center"
        },

      ]
    },
    // {
    //   label: "Member",
    //   url: "member/all",
    //   icon: "fa fa-users"
    // },
    // {
    //   label: "Withdrawal",
    //   url: "withdrawallist",
    //   icon: "fa fa-google-wallet"
    // },


    // {
    //   label: "Web Help",
    //   url: "help",
    //   icon: "fa fa-desktop"   
    // },
    // {
    //   label: "WebHelp",
    //   url: "webhelp",
    //   icon: "fa fa-desktop"   
    // },
    {
      label: "Notification",
      url: "/notificationlist",
      icon: "fa fa-bell"
    },
    {
      label: "Settings",
      url: "setting",
      icon: "fa fa-cog"
    },

  ]

  const toggleSubMenu = (index) => {
    if (openSubMenuIndex === index) {
      setOpenSubMenuIndex(null); // Collapse if already open
    } else {
      setOpenSubMenuIndex(index); // Expand this one
    }
  };

  return (
    <div className="nav">
      <Link to="/dashboard" className='logo'>
        <img src={logo} />
      </Link>
      <ul className='main-nav'>
        {
          menu.map((item, index) => {
            const isSubMenuOpen = openSubMenuIndex === index;

            return <li onClick={() => {

              // setIndexNumsub()
            }} key={index} className={windowpathname == `/${menu[index].url}` ? "active" : ""}>
              <a onClick={() => {
                if (item?.subMenu) {
                  toggleSubMenu(index);
                } else if (item?.url) {
                  navigate(item?.url)
                }
              }} className='menu-main-item'>
                <div>
                  <i className={item.icon} aria-hidden="true">
                  </i>{item.label}
                </div>
                {
                  item?.subMenu != undefined ?

                    <i
                      className={`fa ${isSubMenuOpen ? "fa-angle-down" : "fa-angle-right"}`}
                      aria-hidden="true"
                    ></i>                    // : <i className="fa fa-angle-down" aria-hidden="true"></i>

                    : ''
                }
              </a>


              {item.subMenu && isSubMenuOpen && (
                <ul style={{
                  paddingLeft: 20
                }}>
                  {item.subMenu.map((submenu, subIndex) => (
                    <li
                      key={subIndex}
                      className={windowpathname === `/${submenu.url}` ? "active" : ""}
                    >
                      <a
                        onClick={() => {
                          if (submenu?.url) navigate(submenu.url);
                        }}
                        className='menu-main-item'
                      >
                        <div>{submenu.label}</div>
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          })
        }

      </ul>


    </div>
  )
}
export default Menu;